import * as ReactRedux from 'react-redux'
import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import Modal from 'react-modal'
import PropTypes from 'prop-types'

import * as t from '@rushplay/theme'
import * as common from '@rushplay/common'
import styled from '@emotion/styled'
import { useI18n } from '@rushplay/i18n'

import * as player from './player'
import { Button } from './button'
import { Card } from './card'
import { Heading } from './heading'

const PopupWrapper = styled(Modal)`
  outline: none;
  margin: ${t.spacing(0)};
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: rgb(0, 0, 0, 0.8);
`

export function RealityCheckModal(props) {
  const i18n = useI18n()
  const period = ReactRedux.useSelector(state =>
    player.getRealityCheckPeriod(state.player)
  )

  return (
    <PopupWrapper ariaHideApp={false} contentLabel="contentLabel" isOpen>
      <common.Box display="flex" textAlign="center" fontSize={2}>
        <Card padding={2}>
          <Heading level={3}>
            {i18n.translate('reality-check.reminder')}
          </Heading>
          <common.Box
            pt={0}
            display="flex"
            flexDirection="column"
            alignItems="center"
            lineHeight="1.5"
          >
            {i18n.translate('reality-check.playing-for', {
              time: period / 60000,
            })}
          </common.Box>
          <common.Space py={1}>
            <Button variant="primary" onClick={props.onDismiss}>
              {i18n.translate('reality-check.continue')}
            </Button>
          </common.Space>

          <common.Box
            pt={1}
            display="flex"
            justifyContent="space-around"
            style={{ textDecoration: 'underline' }}
          >
            <common.Box px={0}>
              <ReactRouter.Link to="/account/gambling-history">
                {i18n.translate('reality-check.history')}
              </ReactRouter.Link>
            </common.Box>
            <common.Box px={0}>
              <ReactRouter.Link to="/casino">
                {i18n.translate('reality-check.leave-game')}
              </ReactRouter.Link>
            </common.Box>
          </common.Box>
        </Card>
      </common.Box>
    </PopupWrapper>
  )
}

RealityCheckModal.propTypes = {
  parentNode: PropTypes.object,
  onDismiss: PropTypes.func,
}
